export const getNumaSchedulerBaseUrl = () =>
  process.env.VITE_NUMA_SCHEDULER_API_URL || 'http://localhost:8003';
